import { render, staticRenderFns } from "./DictionariesSettings.vue?vue&type=template&id=b9e12740&"
import script from "./DictionariesSettings.vue?vue&type=script&lang=js&"
export * from "./DictionariesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports